/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiAdminsMutationRequest, PostApiAdminsMutationResponse, PostApiAdmins400, PostApiAdmins401, PostApiAdmins403, PostApiAdmins500 } from "../../types/PostApiAdmins.ts";
import { postApiAdminsMutationResponseSchema, postApiAdminsMutationRequestSchema } from "../../zod/SuperAdminSchemas/postApiAdminsSchema.ts";

function getPostApiAdminsUrl() {
  const res = { method: 'POST', url: `/api/admins` as const }  
  return res
}

/**
 * @summary Создание администратора (Доступно только для суперадмина)
 * {@link /api/admins}
 */
export async function postApiAdmins({ data }: { data?: PostApiAdminsMutationRequest }, config: Partial<RequestConfig<PostApiAdminsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiAdminsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiAdminsMutationResponse, ResponseErrorConfig<PostApiAdmins400 | PostApiAdmins401 | PostApiAdmins403 | PostApiAdmins500>, PostApiAdminsMutationRequest>({ method : "POST", url : getPostApiAdminsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiAdminsMutationResponseSchema.parse(res.data)
}